module.exports = "<daccs-layout [loading]=\"loading\" (manualSocketReconnect)=\"handleManualReconnect($event)\"\n              (dateChangedEvent)=\"dateChangedEvent($event)\"></daccs-layout>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/initialiaze/initialiaze.component.html
// module id = ../../../../../src/app/initialiaze/initialiaze.component.html
// module chunks = main